import mapscapeIcon from '../images/mapscape-icon.png'
import mapscapeGreyscaleIcon from '../images/mapscape-greyscale-icon.png'
import vicmapAerialIcon from '../images/vicmap-aerial-icon.png'
import vicmapCartoIcon from '../images/vicmap-carto-icon.png'
import { basemapTypes, SearchControlPlaceholder } from '../lib/constants'

const mapshareAddressGeocoder =
  'https://corp-geo.mapshare.vic.gov.au/arcgis/rest/services/Geocoder/VMAddressEZIAdd/GeocodeServer'
const mapshareParcelGeocoder = 'https://corp-geo.mapshare.vic.gov.au/arcgis/rest/services/Geocoder/VMParcelSPI/GeocodeServer'
const arcgisServerBaseUrl = 'https://nvr-gis.mapshare.vic.gov.au/arcgis/rest/services'

const mapConfig: any = {
  initialExtent: {
    xmin: 2429801,
    ymin: 2366989,
    xmax: 2568497,
    ymax: 2457491
  },
  arcgisServerBaseUrl: arcgisServerBaseUrl,
  arcgisServerGeometryUrl: `${arcgisServerBaseUrl}/Utilities/Geometry/GeometryServer`,
  basemaps: {
    vicmapCarto: {
      title: 'Vicmap - Carto',
      type: basemapTypes.wmts,
      url: 'https://base.maps.vic.gov.au/service',
      thumbnail: vicmapCartoIcon,
      layerId: 'CARTO_VG',
      serviceMode: 'KVP',
      opacity: 1, // Opacity must be 1 otherwise WMTS basemap covers all operational layers when viewed on mobile device.
      maxScale: 1 // This is set at 1 as otherwise basemap gallery has an issue thinking vicmapAerial is the same layer if they both have the same props
    },
    vicmapAerial: {
      title: 'Vicmap - Aerial',
      type: basemapTypes.wmts,
      url: 'https://base.maps.vic.gov.au/service',
      thumbnail: vicmapAerialIcon,
      layerId: 'AERIAL_VG',
      serviceMode: 'KVP',
      opacity: 1, // Opacity must be 1 otherwise WMTS basemap covers all operational layers when viewed on mobile device.
      maxScale: 0
    },
},
  dynamicMapServices: {
    emisMsa: {
      includeInMap: true,
      url: `${arcgisServerBaseUrl}/EMIS_PUBLIC/EMIS_MSA/MapServer`,
      layers: {
        environmentMitigation: {
          name: 'MSA Environment Mitigation Dataset (EMD)',
          visible: true,
          legendGroup: 'MSA LEVY INFORMATION',
          legendOrder: 1
        },
        scatteredTrees: {
          name: 'MSA Environment Mitigation Dataset Scattered Tree Locations',
          visible: true,
          legendGroup: 'MSA LEVY INFORMATION',
          legendOrder: 2
        },
        paymentStatus: {
          name: 'MSA Payment Status',
          visible: true,
          legendGroup: 'MSA LEVY INFORMATION',
          legendOrder: 3
        },
        levyArea: {
          name: 'MSA Levy Area Boundary',
          visible: true,
          legendGroup: 'MSA LEVY INFORMATION',
          legendOrder: 4
        },
        conservationArea: {
          name: 'MSA Conservation Area',
          visible: true,
          legendGroup: 'MSA GENERAL',
          legendOrder: 5
        },
        omr: {
          name: 'Outer Metropolitan Ring Transport Corridor',
          visible: false,
          legendGroup: 'MSA GENERAL',
          legendOrder: 6
        },
        twelvePrecincts: {
          name: 'Twelve Precincts',
          visible: false,
          legendGroup: 'MSA GENERAL',
          legendOrder: 7
        },
        vpaPrecinctBoundaries: {
          name: 'VPA Precinct Boundaries',
          visible: false,
          legendGroup: 'MSA GENERAL',
          legendOrder: 8
        },
        ugb: {
          name: 'Urban Growth Boundary',
          visible: false,
          legendGroup: 'MSA GENERAL',
          legendOrder: 9
        },
        lgas: {
          name: 'Local Government Areas',
          visible: false,
          legendGroup: 'MSA GENERAL',
          legendOrder: 10
        },
        crownLand: {
          name: 'Crown Land',
          visible: false,
          legendGroup: 'MSA GENERAL',
          legendOrder: 11
        },
        parcels: {
          name: 'Parcels',
          visible: true,
          legendGroup: 'MSA GENERAL',
          legendOrder: 12
        },
        properties: {
          name: 'Properties',
          visible: false,
          legendGroup: 'MSA GENERAL',
          legendOrder: 13
        },
        growlingGrassFrogAreasOfStrategicImportance: {
          name: 'MSA Growling Grass Frog Areas of Strategic Importance',
          visible: false,
          legendGroup: 'PLANNING PERMIT INFORMATION',
          legendOrder: 14
        },
        salvageAndTranslocation: {
          name: 'MSA Salvage and Translocation',
          visible: false,
          legendGroup: 'PLANNING PERMIT INFORMATION',
          legendOrder: 15
        },
        nativeVegetationRegulationsArea: {
          name: 'Native Vegetation Regulations Area',
          visible: true
        }
      },
      tables: {
        msaLevyRates: { name: 'MSA Levy Rates', layerId: 16 }
      }
    },
    parcelAddress: {
      includeInMap: false,
      url: `https://corp-geo.mapshare.vic.gov.au/arcgis/rest/services/Geocoder/VMParcelAddressLookup/MapServer`,
      tables: {
        parcelAddress: { name: 'PARCEL_APPROVED_ADDRESS', layerId: 1 }
      }
    }
  },
  geoprocessingServices: {
    calculateLevyLiabilities: {
      url: `${arcgisServerBaseUrl}/EMIS_PUBLIC/EMIS_Public_HCO_Tools/GPServer/Calculate%20Levy%20Liabilities`
    }
  },
  searchConfig: {
    allPlaceholder: SearchControlPlaceholder,
    includeDefaultSources: false,
    locationEnabled: false
  },
  searchSources: [
    {
      url: mapshareAddressGeocoder,
      singleLineFieldName: 'SingleLine',
      outFields: ['Address'],
      name: 'Street Address',
      minSuggestCharacters: 5
    },
    {
      url: mapshareParcelGeocoder,
      singleLineFieldName: 'SingleLine',
      outFields: ['Address'],
      name: 'Parcel SPI',
      minSuggestCharacters: 3
    }
  ],
  parcelSelectionScale: 25000
}

export default mapConfig
